/**
 * @deprecated - our track function accepts eventName: string
 * There is no need to use this enum anymore
 * If your event is meant to be fired from multiple places, you can store the name in a local const, or in a more global enum
 */
export enum AnalyticsEvents {
    ToggleBookkeeperMode = 'toggle bookkeeper mode',
    ChangeAuditeeCompany = 'switch bookkeeper mode company',
    InstantPayScreenLoaded = 'payment screen loaded',
    InstantPayButtonClicked = 'inline pay button',
    SearchTabSelected = 'search tab selected',
    SearchClose = 'close search',
    SearchClearSearchPhrase = 'clear search phrase',
    SearchSeeAll = 'see all',
    SearchClickedProject = 'select search result project',
    SearchClickedContact = 'select search result contact',
    SearchClickedFile = 'select search result file',
    SearchClickedFlow = 'select search result flow',
    BuilderLoaded = 'flows builder',
    BuilderTopNavBackButtonClicked = 'back button from builder',
    BuilderOpenFlowThemeModal = 'open flow theme modal',
    BuilderRenameFlow = 'rename flow',
    BuilderRenameBlockTemplate = 'rename block template',
    BuilderRenameFlowTemplateConfirm = 'rename flow template confirm',
    BuilderDeleteFlowTemplate = 'delete flow',
    BuilderDeleteBlockTemplate = 'delete block template',
    BuilderOpenSaveFlowAsTemplateModal = 'save flow as template',
    BuilderPreview = 'preview flow',
    BuilderInvoiceDisplaySelected = 'invoice_display_selected',
    BuilderEditInvoiceItemProps = 'edit_invoice_item_properties',
    BuilderPublishFlowWithoutSharing = 'published without sharing',
    ContinueToApp = 'continue to app',
    DownloadApp = 'download app',
    BlockModal = 'block modal',
    ShowVersionHistory = 'version history',
    VersionHistoryDone = 'click done from version history',
    intakeModal = 'intake form modal',
    intakeModalLogin = 'intake form modal login link',
    intakeFormTermsOfService = 'intake form terms of service link',
    intakeModalClickSubmit = 'intake form modal submit',
    intakeModalClickStepOneSubmit = 'intake cta button',
    OptimizeMaxWaitReached = 'optimize max wait time reached',
    intakeFormSubmitError = 'Intake Form Submit error',
    intakeFormEmailValidationFailed = 'email validation failed (client)',
    intakeEmailDomainNotValid = 'Intake form error email domain not valid',
    intakeEmailAlreadyExists = 'Intake form email already exists',
    intakeModalSubmitSuccess = 'success: intake form modal submitted',
    intakeFormSubmitSuccess = 'success: intake form submitted',
    intakeFormSubTypeMenu = 'intake form subtype menu',
    intakeFormSelectedSubType = 'intake form selected subtype menu',
    intakeFormSelectedCompanyTypeForConsultantsExperiment = 'intake form selected company for consultants experiment',
    intakeFormUserAlreadyExists = 'user already exists (redirecting)',
    intakeFormAdobeSignupUser = 'adobe signup user (redirecting)',

    mtaStartTrial = 'mta user trial start',
    facebookSsoNewUser = 'facebook first sign up',

    signupWithGoogle = 'sign up with google',
    signupWithGoogleLoadingPopup = 'google choose email modal',
    ssoUserExists = 'server: user is already hb user',
    signupWithGoogleSuccessful = 'signup with google finished successfully',
    signupWithGoogleUserApproval = 'signup with google user approval',
    signupWithGoogleUserClosedEmailChooser = 'cancel: google choose email modal',

    new_intake_form_ab_test_variant = 'New Intake Form AB Test Optimize Experiment',

    MwebBannerDownloadApp = 'mweb banner download app',
    SetupGuide = 'setup guide',
    SetupGuideTask = 'setup guide task',
    SetupGuideCompleteStep = 'setup guide complete step',
    SetupGuideCompleted = 'setup guide completed',
    MwebBannerGoToDesktop = 'mweb banner go to desktop',
    BuilderTopNavCTAClicked = 'main top bav cta',
    BuilderSaveFlowAsTemplate = 'save flow as template confirm',
    BuilderDuplicateTemplate = 'duplicate template',
    BuilderDefaultEmail = 'default email for flow',
    BuilderSendTestFlowModal = 'send test modal',
    BuilderSendTest = 'send test',
    BuilderDeleteFlow = 'delete flow instance',
    setupGuideShowStepDetails = 'setup guide show step details',

    PricingPlanSelected = 'pricing plan selected',
    VerificationCodeEmailSentFail = 'error: send email of verification code failed',
    VerificationCodeSubmitFail = 'error: access code verification failed',
    BuilderDeleteFlowConfirm = 'delete flow confirm',
    BuilderDeleteFlowTemplateConfirm = 'delete flow template confirm',
    BuilderGoToWorkflows = 'go to workflows',
    BuilderSwitchTab = 'switch to builder tab',
    BuilderGoToResponsesTab = 'next responses',
    BuilderPublishFlow = 'publish flow',
    BuilderUseFlowTemplate = 'use flow template',
    BuilderFontSelected = 'font selected',
    NotifyOnChanges = 'notify participants on changes',
    EditCompanyProjectTypes = 'change project types',
    EditCompanyLeadSources = 'change lead source types',
    EditCompanySpaces = 'change space types',
    EditCompanyProjectFields = 'customize project fields',
    UpdateCompanySpaces = 'update space types',
    UpdateCompanyLeadSources = 'update lead sources',
    UpdateCompanyProjectFields = 'update project fields',
    UndoChanges = 'undo changes',
    PrintResponses = 'print responses',
    UndoChangesConfirm = 'undo changes confirm',
    AutomationsBuilder = 'Workflow Builder',
    AutomationsBuilderTopNavBackButtonClickedToWorkflows = 'navigate to workflows',
    AutomationsBuilderTopNavBackButtonClickedToWorkspace = 'navigate to workspace',
    AutomationRenameAutomation = 'rename workflow',
    AutomationDeleteAutomation = 'delete workflow',
    AutomationRemoveAutomation = 'remove workflow',
    AutomationEditAutomationInstance = 'edit workflow instance',
    AutomationDeleteAutomationSuccess = 'workflow: deleted',
    AutomationDuplicateAutomation = 'duplicate workflow',
    AutomationDuplicateAutomationSuccess = 'workflow: duplicated',
    AutomationApplyModal = 'automation apply modal',
    AutomationCustomizeApply = 'customize automation for project',
    AutomationBuilderApplyAutomation = 'apply automation to project',
    AutomationBuilderAfterApplyViewAutomation = 'view automation',
    AutomationBuilderAfterApplyBackToWorkspace = 'back to workspace',
    AutomationBuilderAddAction = 'workflow add action',
    AutomationBuilderAddStep = 'add workflow step',
    AutomationBuilderEmptyStateHelpCenterLink = 'add workflow empty state help center',
    AutomationBuilderSelectStep = 'select workflow step',
    AutomationBuilderExecuteStep = 'execute workflow step',
    AutomationBuilderSaveWorkflow = 'save workflow',
    AutomationBuilderUnsavedWarning = 'unsaved workflow warning',
    AutomationBuilderSaveWorkflowSuccess = 'success: workflow: updated',
    AutomationBuilderDeleteStep = 'delete workflow step',
    AutomationBuilderDuplicateStep = 'duplicate workflow step',
    AutomationBuilderChangeStepPosition = 'change step position workflow step',
    AutomationsCreateAutomation = 'create workflow',
    AutomationsCreateAutomationSuccess = 'workflow: created',
    AutomationTriggerHelpCenterLink = 'automation trigger help center link',
    HelpCenter = 'help center',
    AutomationsSideBarActionType = 'workflow action type',
    AutomationsSideBarActionTemplate = 'workflow action template',
    AutomationsSideBarActionFolder = 'workflow action folder',
    AutomationsSideBarToggleApproval = 'workflow toggle step require approval',
    AutomationsSideBarSelectInterval = 'workflow select trigger interval',
    AutomationsSideBarOpenActionDropdown = 'workflow open action dropdown',
    AutomationsSideBarChangeTriggerTime = 'workflow change trigger time',
    AutomationPreviewEmail = 'preview email template',
    AutomationCreateNewEmailTemplate = 'automation create new email template',
    AutomationEmailPreviewAction = 'email template preview action',
    CapitalErrorBoundaryLoad = 'error: general wrapper',
    FlowListPage = 'flow list page',
    FlowBuilderWiresCrossed = 'flows builder wires crossed',
    SearchWiresCrossed = 'main search wires crossed',
    CapitalMobileLinkClick = 'click: capital mobile support center link',
    NewFilterTemplatesLinkClick = 'click: new filter templates support center link',
    CapitalFormError = 'error: click error',
    CapitalLoadConsentModal = 'load: loan application credit consent modal',
    CapitalConsentModalAgree = 'click: loan application credit consent modal agree',
    CapitalConsentModalClose = 'click: loan application credit consent modal close',
    CapitalApplicationGeneralChecboxClick = 'click: loan application general consent checkbox',
    CapitalApplicationCreditCheckboxClick = 'click: loan application credit consent checkbox',
    CapitalOfferReviewClick = 'click: loan application review',
    CapitalOfferReviewLoad = 'loaded: loan approval review',
    CapitalOfferReviewAccept = 'click: loan accept offer',
    CapitalOfferReviewReject = 'click: loan reject offer',
    CapitalRejectModalLoaded = 'loaded: loan reject modal',
    CapitalConfirmRejectClick = 'click: loan confirm reject',
    CapitalRejectModalClosed = 'click: loan reject modal close',
    CapitalAcceptModalLoaded = 'loaded: loan accept modal',
    CapitalConfirmAcceptClick = 'click: loan confirm accept',
    CapitalAcceptModalClosed = 'click: loan accept modal close',
    CapitalOfferReviewClickError = 'error: click % error',
    CapitalLandingPageLoaded = 'capital landing page',
    CapitalLandingPageCtaClick = 'capital landing page cta',
    CapitalLandingPageFaqClick = 'capital landing page faq item',
    CapitalLandingPageSliderUsed = 'capital landing page slider used',
    CapitalPageLoaded = 'loaded: capital',
    CapitalNoOfferLoaded = 'capital no offer',
    CapitalClickLoanRequest = 'click: loan application request',
    CapitalLoanApplicationLoaded = 'loaded: loan application',
    CapitalLoanApplicationClick = 'click: loan application',
    CapitalLoanApplicationClickBack = 'click: loan application back',
    CapitalHelpCenterClick = 'click: loan help center',
    CapitalLoanApplicationSubmit = 'click: loan application submit',
    CapitalApplicationSuccess = 'success: loan application sent',
    HbLogo = 'hb logo',
    CapitalClickAmountEdit = 'click: loan amount edit',
    CapitalApplicationCheckboxError = 'error: checkbox error',
    CapitalDashboardSort = 'click: loan dashboard sort',
    CapitalReviewContract = 'click: review loan contract',
    CapitalCloseReviewOffer = 'click: loan approval review close',
    CapitalConsentCheckboxClick = 'click: loan accept modal consent checkbox',
    CapitalDisclosureModalOpened = 'click: opened disclosure modal',
    CapitalDisclosureModalNextClick = 'click: disclosure modal next button',
    CapitalDisclosureModalClose = 'click: close disclosure modal',
    CapitalDisclosureModalCheckbox = 'click: disclosure modal checkbox',
    FlowGalleryLoaded = 'flow gallery',
    FlowGalleryFilter = 'filter flow gallery',
    FlowGalleryMobileFilter = 'flow gallery mobile filter modal',
    FlowGallerySort = 'sort flow gallery',
    GoToFlowTemplate = 'go to template',
    ChooseTemplateSuccess = 'template chosen',
    DuplicateBlock = 'duplicate block',
    CopyBlock = 'copy block to clipboard',
    CopyBlockWithKeyPress = 'copy block to clipboard with key press',
    PasteBlock = 'paste block from clipboard',
    PasteBlockWithKeyPress = 'paste block from clipboard with key press',
    MoveBlock = 'move block',
    PageItemThreeDots = 'pages 3 dots',
    OpenNavBarSidebar = 'open_customize_button_nav_block_sidebar',
    ClickNextOnNavigationBlock = 'click_navigation_button_navigation_block',
    ClickBackOnNavigationBlock = 'click_back_navigation_block',
    ClickEditOnNavigationBlock = 'click_edit_navigation_block',
    ClickPagesNavigationBlock = 'click_pages_dropdown_navigation_block',
    CloseSidebar = 'close_sidebar',
    OpenSidebar = 'open_sidebar',
    EditNavigationButton = 'edit_navigation_button_text',
    ClickPagesButton = 'click_pages_button',
    Action = 'action',
    PageItemActions = 'pages 3 dots action',
    SmartFileResendVerificationCode = 'resend smaf verification code',
    SmartFileVerificationCodeAutoFill = 'smart file verification code auto fill',
    FlowGalleryViewPublisher = 'view flow publisher',
    QuickPreviewTagClick = 'quick preview tag click',
    QuickPreviewNavigation = 'quick preview navigation',
    TemplateQuickPreview = 'template quick preview',
    TemplateQuickPreviewEditCTA = 'template quick preview edit',
    TemplateQuickPreviewSelectCTA = 'template quick preview select',
    TemplateQuickPreviewQuickSaveCTA = 'template quick preview quick save',
    TemplateQuickPreviewDirectUrl = 'direct url template quick preview load',
    SubscriptionPage = 'subscription page',
    SubscriptionPageEditPayment = 'edit payment method',
    SubscriptionPageChangeMembership = 'change membership',
    SubscriptionPageResumeMembership = 'resume membership',
    SubscriptionPageCancelMembership = 'go to cancel membership',
    SubscriptionPageCancelEditCreditCard = 'cancel edit credit card',
    SubscriptionPageUpdateBilling = 'update billing info',
    SubscriptionPageUpdateCardDetails = 'payment method updated',
    SubscriptionPageShowSubscribedMobileAppModal = 'show subscribed mobile app modal',
    SubscriptionPageInvoiceDownload = 'download invoice',
    PricingTierBenefitTooltipShown = 'pricing tier benefit tooltip shown',
    BillingModalSubmitPaymentPlan = 'submit payment plan',
    BillingModalMtaSubscribe = 'mta subscribe',
    BillingModalClose = 'close billing modal',
    PlansFaqQuestionOpen = 'faq question open',
    AccountSetupModalAccepted = 'account setup offer accepted',
    AccountSetupBuyNowModalAccepted = 'redirect to quiz - buy now experience',
    AccountSetupModalDeclined = 'account setup offer declined',
    ApplyPromoCode = 'apply promo code',
    ContractBannerAction = 'header banner action',
    AddSmartFieldAction = 'insert contract content',
    UndoAction = 'undo action',
    RedoAction = 'redo action',
    flowCorruption = 'flow corruption',
    flowError = 'flow error',
    CreateFlow = 'create flow',
    CreateLegacyFile = 'create legacy file',
    OpenCreateFileMenu = 'open_create_file',
    CreateFlowSidebarSelection = 'sidebar section',
    CreateFlowInstance = 'create flow instance',
    CreateFlowViewMore = 'view more',
    CreateFlowFilter = 'filter flow action',
    SelectViewLayout = 'select view layout',
    SignContractFromResponses = 'sign contract from responses',
    ViewContractFromResponses = 'view contract from responses',
    PrintContract = 'print contract',
    EditContract = 'edit contract',
    SignContract = 'sign contract',
    AddNewBlock = 'add new block',
    ImportActionBlockFromFlow = 'import action block from flow',
    ImportPageFromFlow = 'import page from flow',
    SelectContractTemplate = 'select contract template',
    SelectBlockTemplate = 'Select block template from list',
    SelectPaymentScheduleTemplate = 'select payment schedule template',
    SmartFieldHasBeenSelected = 'smart field has been selected',
    AcceptAndSign = 'accept and sign',
    AddNewParticipantFromSignature = 'add new participant from signature',
    CreateBlankTemplate = 'create blank template',
    SaveAndExit = 'save and exit',
    OpenConfigurationModal = 'open configuration modal',
    ExitWithoutSave = 'exit without save',
    ToggleExpiration = 'toggle expiration',
    ToggleAccessCode = 'toggle access code',
    ToggleViewOnlyLink = 'toggle view only link',
    CopyViewOnlyLink = 'copy view only link',
    ResetViewOnlyLink = 'regenerate view only link',
    InviteTeamMemberOnInvite = 'done with add user modal',
    EditRolePermission = 'team settings company permission',
    ExpireNow = 'expire now',
    ReactivateNow = 'reactivate now',
    CompanyFlowTheme = 'company flow theme',
    OpenCompanyFlowThemeModal = 'open company flow theme modal',
    EditCompanyFlowTheme = 'edit company flow theme',
    RevertToGalleryTheme = 'revert to gallery theme from template',
    ApplyCompanyFlowTheme = 'apply company flow theme',
    EditFlowTheme = 'edit flow theme',
    LoadTemplates = 'load: templates',
    CreateTemplate = 'click: create template',
    GoToFlow = 'go to Flow builder',
    CreateSmartTemplateModal = 'create smart template modal',
    SmartTemplateSuggestionModal = 'smart templates suggestion modal',
    CreateSmartTemplateModalNext = 'create smart template modal next',
    CreateSmartTemplateModalBlank = 'create smart template modal start from blank',
    SmartTemplateNext = 'smart template next',
    TemplatesSort = 'click: sort templates',
    TemplatesByType = 'templates by type',
    TemplatesNewFolder = 'click: new folder',
    TemplateFilter = 'filter flow action',
    ExploreGallery = 'click: explore gallery',
    ToggleTemplatesView = 'click: toggle templates view',
    ClickMoveToFolder = 'click: move to folder',
    SuccessFolderCreated = 'success: new folder created',
    SuccessFolderRenamed = 'success: renamed folder',
    FolderMenuClick = 'click: folder menu',
    FolderDoubleClick = 'folder double click',
    SuccessFolderDeleted = 'success: delete folder',
    ErrorRenameFolder = 'error: renamed folder',
    ErrorCreateFolder = 'error: create folder',
    FlowCardMenuClick = 'click: flow card menu',
    FlowCardMenuAction = 'action: flow card menu',
    SuccessTemplateDuplicate = 'success template duplicate',
    SuccessTemplateDelete = 'success template delete',
    SuccessTemplateStar = 'success template star',
    SuccessTemplateMove = 'success template move',
    TemplatesSidebar = 'templates sidebar',
    UploadCustomFont = 'upload custom font',
    UploadCustomFontComplete = 'upload custom font complete',
    DeleteCustomFont = 'delete custom font',
    CloseHBAppScanModal = 'close hb app scan',
    OpenHBAppScanModal = 'open hb app scan',
    ContinueLegacyBuilder = 'click: continue legacy builder',
    CancelLegacyBuilder = 'click: cancel legacy builder',
    FixIssues = 'fix issues',
    PlaidOnExit = 'exit plaid modal',
    PlaidLinkTokenCreationError = 'plaid error: failed to create link token',
    PlaidRedirectPageLoaded = 'plaid: CX redirect page loaded',
    PlaidEvent = 'plaid event',
    MoveToPageViaDropdown = 'move to page from nav block',
    MoveToPageViaSidebar = 'move to page from sidebar',
    AddressValidtion = 'address validation',
    LoadMoreTemplates = 'load more',
    LearnAboutSmartFiles = 'learn about smart files',
    OpenTemplatesFilter = 'open templates filters in sidebar',
    AddTemplateToFlow = 'insert reusable component',
    ReuseInvoiceBlock = 'reuse_invoice_from_template',
    AddPage = 'add page',
    ErrorAddPageToFlow = 'error: insert reusable component',
    SelectReusableTemplate = 'select template from sidebar',
    AddInvoiceFromServiceModal = 'add invoice from service modal',
    AddOrEditSubItemsInServiceSelection = 'add-edit sub-items',
    BuilderTourStarted = 'started builder tour',
    InvoiceTourStarted = 'started invoice tour',
    ContractTourStarted = 'started contract tour',
    BuilderTourFinished = 'finished builder tour',
    InvoiceTourFinished = 'finished invoice tour',
    ContractTourFinished = 'finished contract tour',
    BuilderTourSkipped = 'skipped builder tour',
    InvoiceTourSkipped = 'skipped invoice tour',
    ContractTourSkipped = 'skipped contract tour',
    ResponsesTourStarted = 'started responses tour',
    ResponsesTourFinished = 'finished responses tour',
    ResponsesTourSkipped = 'skipped responses tour',
    WorkspaceTourStarted = 'started workspace tour',
    WorkspaceTourFinished = 'finished workspace tour',
    WorkspaceTourSkipped = 'skipped workspace tour',
    WorkspaceEducationPopup = 'Workspace education popup',
    WorkspaceTourWelcomeModal = 'Workspace tour welcome modal',
    DismissWorkspaceEducationPopup = 'dismiss orkspace education popup',
    GoToCompanySettingsClick = 'go to company settings',
    GoToCompanySettingsBankClick = 'go to company settings bank',
    GrantProAccess = 'action: click grant access',
    RejectProAccess = 'action: click reject access ',
    RevokeProAccess = 'action: click revoke access',
    ChangeSubscription = 'change subscription',
    ChangeSubscriptionModalLoad = 'change subscription modal',
    ChangeSubscriptionModalBack = 'change subscription modal back to plans',
    AddBankDetailsToast = 'add bank details toast after sending a flow',
    AddBankDetailsBanner = 'add bank details banner',
    DismissAddBankDetailsBanner = 'dismiss bank details banner',
    TrialerWelcomeModalLoaded = 'trialer welcome modal loaded',
    TrialerWelcomeModalSkipped = 'trialer welcome modal skipped',
    TrialerWelcomeModalFinished = 'trialer welcome modal finished',
    OpenVideoModal = 'open video modal',
    VideoModal = 'video modal',
    PlayVideoModal = 'play video modal',
    VideoModalWatched = 'watch video modal',
    PlayLearnHowToBuildASmartFileVideo = 'play learn how to build a smart file video',
    WatchLearnHowToBuildASmartFileVideo = 'watch learn how to build a smart file video',
    PrintPage = 'action: print page',
    DownloadPageAsPDF = 'action: download page as pdf',
    PrintOnlyBlock = 'action: print only block',
    ChangeEmailTemplateLogoVisibility = 'action: change email template logo visibility',
    ChangeEmailTemplateButtonText = 'action: change email template button text',
    SaveDefaultEmailTemplate = 'action: save default email template',
    PreviewDefaultEmailTemplate = 'action: preview default email template',
    PrintFlow = 'action: print flow',
    FlowThumbnailDelete = 'flow thumbnail delete',
    FlowThumbnailEdit = 'flow thumbnail edit',
    FlowThumbnailSettings = 'flow thumbnail settings',
    DeleteDraft = 'delete draft',
    ViewPublishedFlow = 'view published flow',
    ClickOnShare = 'share button',
    ClickOnConfigure = 'configure button',
    ClickOnEditFlow = 'edit flow',
    ClickOnEditDraft = 'edit draft',
    ClickOnContinueEditingDraft = 'continue editing draft',
    SendFlowLater = 'send flow later',
    DisabledAutoUpgrade = 'unchecked auto upgrade from starter',
    PayInAdvanceClicked = 'pay in advance clicked',
    MainSideBarLoaded = 'main sidebar loaded',
    PreviewContentLayout = 'action: preview content layout',
    SelectContentLayout = 'action: select content layout',
    DeleteSavedBlock = 'action: delete saved block',
    ConfirmDeleteSavedBlock = 'confirm: delete saved block',
    CancelDeleteSavedBlock = 'cancel: delete saved block',
    SuccessSavedBlockDeleted = 'success: block deleted',
    ShowContractDisputeWarning = 'move contract modal appears in builder',
    DismissContractDisputeWarning = 'click dont move',
    AcceptContractDisputeWarning = 'click move button',
    FieldNameTooltipAppears = 'field name tooltip appears',
    FieldContentTooltipAppears = 'field content tooltip appears',
    SelectServiceItemSearchResult = 'action: service item search result',
    GoToTemplateGallery = 'go to template gallery',
    CreateNewServiceItem = 'create new service item',
    OpenServicesAutoCompletePopover = 'open services auto complete popover',
    DeleteServiceItemFromBank = 'click: delete service item from items bank',
    MwebSetupGuideStep = 'setup guide task',
    GoToFlowContract = 'go to flow contract',
    GoToFlowPayment = 'go to flow payment',
    CXNextClick = 'click: client experience next',
    CXPaymentToastLoaded = 'loaded: client experience payment toast',
    PayConfirmModalLoaded = 'loaded: client pay confirmation modal',
    PayConfirmModalClick = 'click: client pay confirmation modal',
    CXPaymentToastClickedOnContinue = 'click: client experience toast continue without payment',
    CXContinueWithoutPay = 'client continues without pay',
    CreateClient = 'create client',
    CreateProject = 'create project',
    CreateServices = 'create services',
    CreateInvoice = 'create invoice',
    CreateRecurringInvoice = 'create recurring invoice',
    CreateContract = 'create contract',
    CreateScheduler = 'create scheduler',
    CreateQuestionnaire = 'create questionnaire',
    CreateMeeting = 'create meeting',
    CreateService = 'create service',
    CreateSessionSelection = 'create session selection',
    CreateNew = 'create new',
    MarkAllMessagesAsRead = 'mark all messages as read',
    TrialerUpgrade = 'trialer upgrade',
    HomeMobileExploreTools = 'home mobile explore tools',
    ChangeCampaign = 'change campaign',
    GoToProsPage = 'go to pros page',
    CloseProAd = 'close pro ad',
    CXAddNewCreditCard = 'client added new credit card',
    LoadDollarPromoModal = 'dollar promo modal',
    CancelDollarPromoModal = 'dollar promo modal',
    ClickApplyDollarPromo = 'apply dollar promo',
    SearchArticle = 'search article',
    SeeMore = 'see more',
    ClickOutside = 'click outside',
    ChangeSignatureDetails = 'change signature details',
    GetPaidWizardModal = 'get paid wizard modal',
    CloseGetPaidWizardModal = 'close get paid wizard modal',
    SendTestOnboardingModal = 'send test onboarding modal',
    SelectSendTestTemplate = 'select send test template',
    OnboardingSendTestFlow = 'send test flow from onboarding modal',
    SendTestSetupGuidePreviewToast = 'send test setup guide toast link',
    SendTestSetupGuideLastPageModal = 'send test setup guide last page modal',
    SendTestSetupGuideLastPageLink = 'send test setup guide last page modal link',
    SendTestSetupGuideExitToProject = 'send test setup guide exit to project',
    ExitPreview = 'exit preview',
    WhatBlockDoYouWantToAdd = 'what block do you want to add',
    PromptInvoiceAwareness = 'prompt invoice awareness',
    ResponseInvoiceBanner = 'responses invoice banner',
    ResponsesAddInvoice = 'responses add invoice',
    WorkspaceInvoiceBanner = 'workspace invoice banner',
    WorkspaceCreateInvoice = 'workspace create invoice',
    DontShowMeRecommendedTemplates = "don't show me this",
    ShowMoreTemplates = 'show more templates',
    TourBeforeOnboarding = 'tour before onboarding modal',
    TourBeforeOnboardingNav = 'tour before onboarding navigation',
    WarningModalClickEditContract = 'click edit contract',
    WarningModalClickEditTemplate = 'click edit template',
    WarningModalClickUseTemplate = 'click use template',
    WarningModalQuickApplyClickEdit = 'click edit template',
    WarningModalQuickApplyClickApply = 'click use template',
    OpenServiceSettingsFromResponses = 'open service block settings from responses',
    CreateInvoiceWithServicesFromResponses = 'create invoice with services from responses',
    EmailTemplateEditorTopNavBackButtonClicked = 'back button from email template editor',
    SelectTemplate = 'select template',
    ClosePushToGalleryModal = 'close push to gallery modal',
    TemplateGallery = 'template_gallery',
    TransformFilePopup = 'transform file popup',
    TransformMyFiles = 'transform my files',
    AccountSetupOffer = 'account setup offer',
    ShareFlowTemplate = 'click: share flow template with a member',
    BuilderMenuClick = 'builder menu',
    ShareFlowTemplateError = 'error: error while sharing template',
    ShareFlowTemplateSuccess = 'success: shared template with a user',
    OpenSharedTemplatePreviewModal = 'success: open shared template preview modal',
    OpenSharedTemplatePreviewModalError = 'error: user dont have permissions to see shared template',
    ChangeSelectedFolderForSharedTemplate = 'click: change folder to save shared flow template',
    SaveSharedFlowTemplate = 'click: save shared flow template',
    SaveSharedFlowTemplateError = 'error: cant save template',
    SaveSharedFlowTemplateSuccess = 'success: shared flow template saved',
    flowWithCustomFonts = 'flow has custom fonts',
    LearnMoreAboutFeeUpdate = 'learn more about update',
    LearnMoreAboutEmailVerification = 'learn more email verification',
    OpenEmailVerificationModal = 'open email verification modal',
    EmailVerificationSentAgain = 'email verification sent again',
    ClickDeleteTemplate = 'action: click delete template',
    ClickDuplicateEmailTemplate = 'action: click duplicate email template',
    SuccessTemplateUpdated = 'success: template updated',
    UpdateFlowFromUnsavedChangesPopup = 'click save changes',
    ExitFlowWithoutSaveFromUnsavedChangesPopup = 'click exit without save',
    GoToMyPayments = 'go to my payments',
    EnableCardOnFileModalCtaForTeamMember = 'enable card on file modal cta click for team member',
    GoToCardOnFilePayments = 'go to card on file payments settings',
    EnableCardOnFileBannerLoad = 'enable card on file banner load',
    EnableCardOnFileModalLoad = 'enable card on file modal load',
    ActiveRecurringFilesModalLoad = 'active recurring legacy files modal load',
    ActiveRecurringFilesModalDismiss = 'dismiss active recurring legacy files modal',
    ActiveRecurringFilesModalCtaClick = 'active recurring legacy files modal cta click',
    CloseActiveRecurringFilesModal = 'close active recurring legacy files modal',
    DismissEnableCardOnFileBanner = 'dismiss enable card on file banner',
    DismissEnableCardOnFileModal = 'dismiss enable card on file modal',
    OpenCardPaymentsSection = 'open card payments section',
    CloseCardPaymentsSection = 'close card payments section',
    DisableCardOnFile = 'disable card on file',
    KeepCardOnFile = 'keep card on file',
    ActivateCardOnFile = 'activate card on file',
    ViewAllTeamPipeline = 'view all team members',
    CloseEnableCardOnFileModal = 'close enable card on file modal',
    ClientVersioning = 'client versioning',
    MergeClientChanges = 'merge client changes',
    MarkAsPaid = 'Mark as paid',
    BlockMwebAppStoreButton = 'download app',
    BlockMwebPage = 'block mweb',
    IntentInSetupGuide = 'intent in setup guide',
    ContractChangeWarningModalClickKeepEditing = 'click keep editing',
    ContractChangeWarningModalClickUpdateTemplate = 'click update templates',
    ClickOnSessionConfigFromList = 'session config from list',
    ClickOnCreateNewSessionConfig = 'create new session config',
    ClickEditSessionConfig = 'Edit session config',
    ClickChangeSessionConfig = 'change session config',
    SessionRequirementsChanged = 'session requirements changed',
    ClickOnGoToInvoice = 'go to invoice',
    GoToSessionSelection = 'go to session selection',
    ClickOnCancelMeeting = 'cancel meeting',
    ClickOnConfirmCancelMeeting = 'confirm cancel meeting',
    ClickOnKeepMeeting = 'keep session',
    ClickOnSelectTimeSlot = 'select timeslot',
    RescheduleSessionConfigurationChangedPoUp = 'before you reschedule: availability changed',
    RescheduleSessionConfigurationDeletedPoUp = 'before you reschedule: session disabled/deleted',
    RescheduleMeetingMode = 'client clicked reschedule',
    ClickOnTimezoneDropDown = 'client click on timezone dropdown',
    OneHomeOverview = 'home overview',
    OneHomeWishListModalOpen = 'suggest home module',
    OneHomeWishListModalDismiss = 'dismiss widget suggestion modal',
    OneHomeWishListModalSubmit = 'submit widget suggestion',
    ClickChangedTimezone = 'client changed timezone dropdown',
    ClickOnAddToGoogleCalendar = 'add to google calendar',
    SelectTimeToContinueErrorToast = 'select time to continue error toast',
    SelectTimeToContinueWarningToast = 'select time to continue warning toast',
    SlotNotAvailable = 'slot not available',
    MeetingWasScheduled = 'meeting was scheduled',
    MobileSelectedPageNotNotExistInPages = 'mobile selected page not exist in pages',
    SchedulerBlockNoAvailabilities = 'no availability',
    SchedulerBlockHasAvailabilities = 'has availability',
    SchedulerBlockSlotReset = 'scheduler block slot reset',
    ForceAutopayOnCardOnFileDisabled = 'card on file disabled but didnt changed must-autopay on flow',
    SignupGoogleOneTapError = 'signup google one tap error',
    SignupGoogleOneTapLoad = 'signup google one tap',
    SignupGoogleOneTapDisplay = 'signup google one tap display',
    SignupGoogleOneTapSuccess = 'signup google one tap success',
    SignupABTestStarted = 'signup ab test started',
    EditCompanyProjectTypesModalLoaded = 'project types modal',
    EditCompanyProjectTypesModalClosed = 'project_type__modal_closed',
    EditCompanyProjectTypesModalItemEdit = 'project_type__item_edit_clicked',
    EditCompanyProjectTypesModalDelete = 'project_type__item_delete_clicked',
    EditCompanyProjectTypesModalDeleteConfirmed = 'project_type__item_delete_confirmed',
    EditCompanyProjectTypesModalDeleteCanceled = 'project_type__item_delete_canceled',
    EditCompanyProjectTypesModalAdded = 'project_type__item_added',
    EditCompanyProjectTypesSetAsDefault = 'project_type__item_set_as_default',
    EditCompanyProjectTypesSaveClicked = 'project_type__item_save_clicked',
    TasksAddNewTask = 'task mgmt: add new task',
    TasksDeleteTask = 'task mgmt: delete task',
    TasksAssignToTeamMember = 'click to assign task to a team member',
    WorkflowMarkAsDeclined = 'workflow: mark as declined',
    WorkflowMarkAsApproved = 'workflow: mark task as approved',
    TasksMarkCompleteTask = 'task mgmt: mark task as complete',
    TasksMarkNotCompleteTask = 'task mgmt: remove task from complete status',
    TasksUpdateTask = 'task mgmt: update task',
    InvoiceBlockEnableDiscount = 'enable_discount',
    AddInvoiceParticipant = 'add_participant',
    UpdateInvoiceTitle = 'update_invoice_title',
    UpdatePo = 'update_purchase_order',
    ClickBillTo = 'bill_to',
    UpdateBillTo = 'update_bill_to_text',
    InvoiceBlockDisableDiscount = 'disable_discount',
    InvoiceBlockSwitchSidebarTab = 'switch_sidebar_tab',
    SwitchInvoiceType = 'switch_invoice_type',
    viewAllInvoices = 'view_all_invoices',
    LeaveTip = 'leave_tip',
    LateFeeToggled = 'late_fee_toggle',
    GoToPaymentPage = 'go_to_payments',
    NavigateToPricing = 'navigate to pricing',
    GoToPricing = 'GoToPricing',
    DeletePayment = 'delete_payment',
    AddPayment = 'add_payment',
    OpenPaymentsDotsMenu = 'dots_menu',
    UpdateTaxName = 'update_tax_name',
    DeleteTax = 'delete_tax',
    SwitchTaxType = 'switch_tax_type',
    UpdateTaxValue = 'update_tax_value',
    AddTax = 'add_tax',
    DisplayTax = 'display_tax',
    UpdateBackgroundColor = 'update_background_color',
    UpdateBackgroundColorOpacity = 'update_background_color_opacity',
    UpdateColumnsColor = 'update_columns_color',
    DisplayAllImages = 'display_all_images',
    DisplayCompanyLogo = 'display_company_logo',
    DisplayCompanyDetails = 'display_company_details',
    DisplayProjectDetails = 'display_project_details',
    DisplayInvoiceTitle = 'display_invoice_title',
    DisplayPo = 'display_purchase_order',
    DisplayBillTo = 'display_bill_to',
    DisplayQuantityAndUnit = 'display_quantity_and_unit_price',
    DisplayUnit = 'display_unit',
    UpdatePadding = 'update_padding',
    UpdatePaymentAmount = 'update_payment_amount',
    UpdatePaymentDate = 'update_payment_date',
    UpdateServiceQuantity = 'update_service_quantity',
    DeleteServiceItem = 'delete_service_item',
    UpdateServiceImage = 'update_service_image',
    DeleteServiceImage = 'delete_service_image',
    EditInvoiceTaxes = 'edit_invoice_taxes',
    UpdateServiceUnit = 'update_service_unit',
    UpdateServicePrice = 'update_service_price',
    ApplyTaxToService = 'apply_tax_to_service_item',
    DisplayServiceImage = 'display_service_image',
    UpdateServiceDescription = 'update_service_description',
    SwitchTabServiceList = 'switch_tab_service_list',
    AddServiceItem = 'add_service_item',
    OpenMenuItemsDisplay = 'open_menu_items_display',
    OpenMenuHeaderDisplay = 'open_menu_header_display',
    UpdateBillToFromDropdown = 'update_bill_to_from_dropdown',
    OpenBillToDropdown = 'open_bill_to_dropdown',
    UseAutopay = 'use_autopay',
    ServiceFromServiceTemplate = 'service_from_service_template',
    ManageServices = 'manage_services',

    SwitchPaymentOptions = 'switch_payment_options',
    InvoiceBlockClickSidebarSection = 'sidebar_section',
    SwitchDiscountTypeToAmount = 'switch_discount_to_amount',
    SwitchDiscountTypeToPercentage = 'switch_discount_to_percentage',
    UpdateDiscountValue = 'update_discount_value',
    YearInReviewLoaded = 'year in review',
    RestartYearInReview = 'restart year in review',
    ShareYearInReview = 'share year in review',
    ExitYearInReview = 'exit year in review',
    YearInReviewGetReferralsLink = 'get link CTA in referrals page',
    ProRequestAccess = 'click request access',
    ProLoginAsMember = 'click on login as member',
    ProArchiveRequest = 'click on archive access',
    BankIntegrationFaqQuestionOpen = 'bank integration faq question open',
    BankIntegrationFaqQuestionLink = 'bank integration faq question link',
    ClickAddBankInfo = 'add bank info',
    LoadBookKeepingPaymentsEmptyState = 'bookkeeping payments empty state',
    ClickBookKeepingPaymentsEmptyStateLink = 'bookkeeping payments empty state link',
    LoadCompanySettingsPaymentIntegration = 'company setting payment integration',
    GoToIntegrations = 'go to integrations',
    ClickSetupOnlinePaymentsLink = 'setup online payments link',
    TAL_BUCKET_SURVEY_MODAL_OPENED = 'tal bucket survey: modal opened',
    TAL_BUCKET_SURVEY_MODAL_CLOSED_WITHOUT_ANSWERING = 'tal bucket survey: modal closed',
    TAL_BUCKET_SURVEY_MODAL_CLOSED_ON_VALUE_PROPOSITION = 'tal bucket survey: closed value proposition',
    TAL_BUCKET_SURVEY_MODAL_CLOSED_ON_PAYMENT_TOOL = 'tal bucket survey: closed payment tool questions',
    TAL_BUCKET_SURVEY_MODAL_CLOSED_ON_INVOICED_CREATED = 'tal bucket survey: closed invoice created',
    TAL_BUCKET_SURVEY_MAIN_ANSWER_SELECTED = 'tal bucket survey: answered q1',
    TAL_BUCKET_SURVEY_VALUE_PROPOSITION_LOADED = 'tal bucket survey: value proposition',
    TAL_BUCKET_SURVEY_PAYMENT_TOOL_QUESTIONS_LOADED = 'tal bucket survey: payment tool questions',
    TAL_BUCKET_SURVEY_BUTTON_CLICKED_ON_PAYMENT_TOOL = 'tal bucket survey: payment tool continue',
    TAL_BUCKET_SURVEY_BUTTON_CLICKED_ON_VALUE_PROPOSITION = 'tal bucket survey: value proposition continue',
    TAL_BUCKET_SURVEY_COMPLETED = 'tal bucket survey completed',
    TAL_BUCKET_SURVEY_INVOICE_CREATED_LOADED = 'tal bucket survey: invoice created',
    TAL_BUCKET_SURVEY_INVOICE_CREATED_BUTTON_CLICKED = 'tal bucket survey: invoice continue',
    SaveAsTemplateSuggestionModal = 'save as template suggestion modal',
    SaveAsTemplateSuggestionDecline = 'do not save',
    SaveAsTemplateSuggestionAccept = 'save as template',
    saveConfigurationChanges = 'click save & exit in the configure settings',
    saveDraftInvoiceConfig = 'save configuration for draft invoice toggle',

    MembershipBillingPeriod = 'membership billing period',
    MembershipToggleOpenTable = 'membership toggle open table',
    OnboardingLoadStep = 'setup guide',
    OnboardingClickNext = 'setup guide next',
    OnboardingClickBack = 'setup guide back',
    UploadCompanyLogo = 'edit company icon',
    UploadUserProfile = 'user avatar',
    SetBrandColor = 'set brand color',
    OnboardingAddService = 'onboarding add service',
    OnboardingUpdateService = 'onboarding service updated',
    UpgradeBadgeOnFeature = 'upgrade badge',
    UpgradeBannerOnFeature = 'upgrade banner',
    UpgradeSeePlans = 'upgrade see plans',
    FeatureBlockSeePlans = 'feature block see plans',
    FeatureBlockCloseModal = 'feature block close modal',
    EmailVerificationCloseModal = 'email verification close modal',
    MembershipFeatureBlockModal = 'membership feature block modal',
    FeatureRestrictedSection = 'feature restricted section',
    ClickBlockedFeature = ' blocked feature',
    OnboardingSchedulerLinkCopy = 'onboarding scheduler link copy',
    OnboardingComplete = 'onboarding complete',
    PreviewFile = 'preview file',
    PreviewLastPageModal = 'preview last page modal',
    CollapseOnboarding = 'collapse onboarding',
    ReferralsModal = 'referrals modal',
    CloseReferralModal = 'close referral modal',
    ShareLink = 'share link',
    ReferralLinkShared = 'referral link shared',
    ShareLinkCopy = 'share link copy',
    MyBenefitsButton = 'my benefits button',
    GoToReferralDashboard = 'go to referral dashboard',
    SwitchToReferTab = 'refer again',
    SwitchToResourcesTab = 'resources tab',
    SwitchToStatusTab = 'referral tracking',
    ReferralHelpCenter = 'referral help center',
    TermsAndCondition = 'terms and condition',
    ReferralTOS = 'referral tos',
    ReferAFriend = 'refer a friend',
    OnboardingSchedulerSessionFieldChanged = 'onboarding scheduler session field changed',
    OnboardingLeadCaptureSessionFieldChanged = 'onboarding lead capture session field changed',
    OnboardingSchedulerSessionUpdated = 'onboarding scheduler session updated',
    OnboardingPublicFlowFieldChanged = 'onboarding public flow field changed',
    OnboardingPufSchedulerPublished = 'onboarding puf scheduler published',
    ReportsExportClick = 'export report',
    ReportChangeTimeFrame = 'change report time frame',
    DowngradeModalClose = 'features downgrade modal closed without continue',
    DowngradeModalContinue = 'features downgrade modal confirmed and continue',
    DowngradeModalOpen = 'features downgrade modal open',
    ReferralSuccessKit = 'see referral success kit',
    DownloadAsset = 'download asset',
    ShowAll = 'show all',
    StartTest = 'start test',
    ContactSupport = 'contact support',
    GoYearlyModal = 'go yearly modal',
    ThirtyDayTrialModal = '30 day trial modal',
    AddToExistingProject = 'Add to existing project',
    CreateNewProject = 'Create new project',
    LoadAddClientToProject = ' Create or add client to project',
    DeleteContact = 'delete contact',
    BlockedAccessModal = 'blocked access modal',
    MembershipTabPricingTiers = 'company setting membership tab - pricing tiers',
    OpenInvoicePaymentsCard = 'open invoice payments card',
    OpenInvoiceModal = 'open invoice modal',
    OpenLegacyInvoice = 'open legacy invoice',
    PaymentsTabChange = 'payments tab change',
    SchedulerTroubleshooterTimezoneChanged = 'scheduler troubleshooter timezone changed',
    ExpandableView = 'expandable view',
    LifecycleMarketingLink = 'lifecycle marketing link',
    ContactViewAllProjects = 'view all projects',
    ScrollClientView = 'client workspace',
    ParticipantModalLoad = 'WorkspaceParticipantModal',
    VideoBlockSetVideoLink = 'set video link',
    VideoBlockSettingToggle = 'video block setting toggle',
    RevokeBookkeeperAccessClicked = 'revoke bookkeeper access clicked',
    RevokeBookkeeperAccessConfirmed = 'revoke bookkeeper access confirmed',
    ExtendBookkeeperAccessClicked = 'extend bookkeeper access clicked',
    ExtendBookkeeperAccessConfirmed = 'extend bookkeeper access confirmed',
    GrantBookkeeperAccessClicked = 'grant bookkeeper access clicked',
    GrantBookkeeperAccessConfirmed = 'grant bookkeeper access confirmed',
    RevokeBookkeeperAccessCancelled = 'revoke bookkeeper access cancelled',
    OpenFiltersComponent = 'open filter menu',
    InstantBrandingQuiz = 'instant branding quiz',
    InstantBrandingQuizNoWebsite = 'user did not enter website on intake form',
    InstantBrandingClearAssets = 'instant branding clear assets',
    SearchContacts = 'search contacts',
    ClearAllFilters = 'clear all filters',
    FilterClicked = 'click on filter',
    ContactsListLoad = 'contacts',
    ContactsListTabClick = 'contacts tab',
    AddContact = 'add contact',
    AddProjectCheckbox = 'add project checkbox',
    AddOrganizationModal = 'add client organization modal',
    OrganizationNameClicked = 'click organization name',
    OrganizationActions = 'organization_actions',
    EditOrganization = 'edit_organization',
    DeleteOrganization = 'delete_organization',
    CancelDeleteOrganization = 'cancel_delete_organization',
    AddContactToOrganization = 'add_contact_to_organization',
    OrganizationName = 'organization_name',
    AddContactModal = 'add contact modal',
    EditContactModal = 'edit contact modal',
    DownloadClients = 'download clients',
    SendFile = 'send file',
    SortList = 'sort list',
    ContactToggledPreferred = 'contact toggled preferred',
    CloseProjectsModal = 'close projects modal',
    ContactOptions = 'contact_options',
    ToggleSelectItem = 'toggle select item',
    ToggleSelectAll = 'toggle select all',
    SendEmailContacts = 'send email contacts',
    DeleteContacts = 'delete contacts',
    ClearSelectedContacts = 'clear selected contacts',
    ClosePipelineContactsBanner = 'click: close pipeline banner',
    GoToContactsFromPipelineBanner = 'click: go to contacts from pipeline banner',
    GoToGmailIntegration = 'go to gmail integration',
    FormMemberToastAppear = 'action: form member toast appear',
    FormMemberToastCTAClicked = 'click: form member toast cta',
    ClickTabContactView = 'client workspace tab',
    GoToWorkspace = 'go to workspace',
    GoToContactWorkspace = 'go to contact workspace',
    ClickOpenEmailComposer = 'open email composer',
    ManageFileAccessModal = 'manage_file_access_modal',
    CopyToClipboardShareableLink = 'copy_to_clipboard_file_shareable_link',
    CloseManageFileAccessModal = 'close_manage_access_file_permission_modal',

    // #region LEAD FORMS
    PublicFlowAutomationToggle = 'public flow automation toggle',
    PublicFlowSelectAutomation = 'public flow select automation',
    PublicFlowEmailConfirmationToggle = 'public flow email confirmation toggle',
    PublicFlowTemplateClick = 'template_click',
    NewPublicFlow = 'click: click create new form',
    TogglePublicFormOn = 'action: turn live form on',
    CopyPublicLink = 'click: click copy',
    ViewLivePublicFlow = 'click: click on cx',
    DeactivatePublicFlow = 'action: click turn off form',
    OpenPublicFlowFromBuilder = 'click: view live form',
    FlowGalleryImportPublicFlow = 'import public flow',
    FlowGalleryCustomizePublicFlow = 'import and customize public flow',
    FlowGalleryPreview = 'preview public flow',
    FlowGalleryPreviewFromUrl = 'preview public flow from url',
    OutdatedPublicFlowReload = 'Outdated public flow tried to submit and reloaded',
    PublicFlowNotFound = 'load: 404 error when form is inactive',
    PublicFlowGoToNextPage = 'click: click next in public flow',
    DeletePublicFlow = 'click: delete public flow',
    PublicCXBackClick = 'public cx back button click',
    CreateNewPublicFile = 'create_new_public_file',
    CreateLeadFormFromBanner = 'click: create_lead_form_banner',
    LeadFormShareModalPreview = 'click: preview',
    LeadFormShareModalAdvancedEditing = 'click: advanced editing',
    LeadFormPublish = 'publish lead form',
    LeadFormInCreateNewMenu = 'public_flows',
    LeadFormInQuickActionsPanel = 'create lead form home quick actions',

    // #region LEAD FORM DEMO SUCCESS MODAL
    LeadFormDemoRestartDemo = 'restart demo',
    LeadFormDemoStartTrial = 'start trial',
    LeadFormDemoCloseSuccessModal = 'close success modal',
    LeadFormDemoPay = 'demo pay',
    // #endregion LEAD FORM DEMO SUCCESS MODAL

    // #region LEAD FORM WIZARD
    ExitLeadFormWizard = 'exit lead form wizard',
    GoToNextSection = 'go to next section',
    GoToPrevSection = 'go to prev section',
    LoadLeadFormWizard = 'lead form wizard',
    SubmitLeadFormWizard = 'submit lead form wizard',
    // #endregion LEAD FORM WIZARD
    // #endregion LEAD FORMS

    // #region ONE COMPOSER
    BuilderCopyFlowDirectLink = 'copy flow direct link',
    BuilderSendFlowViaEmail = 'send flow via email',
    BuilderShareModalCancel = 'cancel create link flow',
    BuilderShareModalCreateLink = 'create link flow',
    BuilderSharePreviewEmail = 'preview email',
    ClickSaveAsTemplate = 'action: click save as template',
    ClickSendEmail = 'click: send email',
    EmailAttachmentAdded = 'email attachment: added',
    EmailAttachmentRemoved = 'email attachment: removed',
    EmailContentEducationLink = 'email content education link',
    RemoveSchedulingEmail = 'remove scheduling email',
    ToggleFormattingToolbar = 'action: toggle formatting toolbar',
    ToggleLogoVisibility = 'action: toggle logo visibility',
    TurnOnAccessCode = 'turn on access code',
    // Related events that are not under the one_composer appPath:
    BuilderSendTestFlowViaEmail = 'send test flow via email',
    LandedOnShareRoute = 'landed on share route',
    SawFirstShareCongratsModal = 'saw first share congrats modal',
    ShareModalOpened = 'share modal opened',
    ShareTourFinished = 'finished share tour',
    ShareTourSkipped = 'skipped share tour',
    ShareTourStarted = 'started share tour',
    // #endregion OneComposer

    // #region NOTIFICATIONS CENTER
    load_notifications_center = 'load: notifications center',
    open_debit_card_modal = 'open debit card modal',
    automations_update_notification = 'automations update notification',
    activity_notifications_settings_toggle = 'activity_notifications_settings_toggle',
    activity_notifications_settings_view_toggle = 'click: toggle activity notification settings view',
    activity_notifications_mark_all_as_read = 'click: mark all notifications read',
    activity_notifications_filter_toggle = 'click: toggle activity notifications filter',
    activity_notification = 'click: activity notification',
    mark_activity_notifications_read = 'click: mark activity notifications read',
    mark_activity_notifications_unread = 'click: mark activity notifications unread',
    // #endregion NOTIFICATIONS CENTER

    // #region TOP NAV EVENTS
    UserAvatar2023 = 'user avatar 2023 ',
    TopNav2023 = 'top nav 2023',
    TopNavPublicProfile = 'public profile',
    TopNavAccountSettings = 'account settings',
    TopNavLogout = 'logout',
    TopNavSwitchPro = 'switch pro',
    TopNavClick = 'top_nav',
    TopNavMenuItem = 'top_nav_menu_item',
    CloseMinimalTopNav = 'close',
    HomeTopNav = 'home',
    SetupTopNav = 'setup guide',
    ProjectsTopNav = 'projects',
    ContactsTopNav = 'contacts',
    LeadFormsTopNav = 'public_flows',
    ContactFormTopNav = 'contact form',
    ChromeExtensionTopNav = 'chrome extension',
    BatchEmailsTopNav = 'batch email',
    GiftCardsTopNav = 'gift card',
    LibraryTopNav = 'library',
    CalendarTopNav = 'calendar',
    SchedulerTopNav = 'scheduling',
    TasksTopNav = 'tasks',
    TimeTrackerTopNav = 'time_tracker',
    FilesTopNav = 'files templates',
    ServicesTopNav = 'services',
    EmailsTopNav = 'emails',
    PackagesTopNav = 'packages',
    AutomationsTopNav = 'workflow',
    GalleryTopNav = 'template_gallery',
    ReportsTopNav = 'reports',
    FinancesBalanceTopNav = 'balance',
    FinancesOverviewTopNav = 'finance_overview',
    PaymentsTopNav = 'payments',
    ExpensesTopNav = 'expenses',
    QuickbooksTopNav = 'quickbooks',
    CapitalTopNav = 'capital',
    ProfitLossTopNav = 'profit_n_loss',
    BankDetailsTopNav = 'bank_details',
    HelpCenterTopNav = 'help center',
    WebinarsTopNav = 'webinars',
    BlogTopNav = 'blog',
    Referrals = 'Referrals',
    HoneybookProsTopNav = 'go to pros page',
    HoneybookCommunityTopNav = 'go to community page',
    HoneybookAcademyTopNav = 'go to academy page',
    BusinessDirectoryTopNav = 'creatives',
    Account = 'account',
    SwitchCompanies = 'switch companies',
    SwitchCompany = 'switch company',
    AddCompany = 'add company',
    Company = 'company',
    ClientPortalSendUrl = 'client portal send url',
    ClientPortalCopyUrl = 'client portal copy url',
    ConnectCustomSubdomain = 'connect company subdomain',
    RetryConnectCustomSubdomain = 'try again failed subdomain',
    CreatedCnameRecord = 'created cname record',
    LearnMoreOnDomains = 'learn more on domains',
    LearnMoreOnSubdomains = 'learn more on subdomains',
    LearnMoreOnCnameRecords = 'learn more on cname records',
    openEasyConnectPopup = 'open easy connect popup',
    EnterSubdomainVerification = 'enter subdomain',
    CreateSubdomainVerification = 'create subdomain',
    EasyConnectPopupClosed = 'easy connect domain popup closed',
    ConfirmedEasyConnectDomainButton = 'confirmed easy connect domain button',
    ConfirmEasyConnectDomainConnection = 'confirm easy connect domain confirmation',
    ConfirmDomainConnection = 'confirm domain connection',
    ConfirmDomainConnectionSuccess = 'got it',
    clientPortalPreviewLoginScreen = 'client portal preview login screen',
    clientPortalLoginSubmit = 'client portal login submit',
    clientPortalLoginMagicLink = 'client portal login magic link',
    clientPortalLoginMagicLinkSubmit = 'client portal login magic link submit',
    clientPortalLoginForgotPasswordSubmit = 'client portal login forgot password submit',
    clientPortalLoginForgotPassword = 'client portal login forgot password',
    clientPortalPreviewMagicLink = 'client portal preview magic link',
    clientPortalPreviewForgotPassword = 'client portal preview forgot password',
    clientPortalEditSettings = 'client portal edit settings',
    clientPortalPreviewSettingsUpload = 'client portal preview settings upload',
    clientPortalToggleLogoType = 'client portal toggle logo type',
    clientPortalToggleLoginTitle = 'client portal toggle login title',
    editedClientProfileConfirmed = 'client portal confirmed edit',
    clientPortalCustomizeScreenExit = 'client portal customize screen exit',
    clientPortalCustomizeScreenSave = 'client portal customize screen save',
    clientPortalCustomizeScreenToggleDevice = 'client portal customize screen toggle device',
    clientPortalToggleShowLogo = 'client portal toggle show logo',
    Integrations = 'go to integrations',
    SetupGuideTopNav = 'setup-guide',
    InvoicesPage = 'invoices page',
    SideNav = 'side_nav',
    // #endregion TOP NAV EVENTS

    // #region BATCH EMAILS
    LoadBatchEmails = 'batch emails',
    ClickProtipLearnMore = 'help center',
    ClickGoToAccountSettings = 'confirm goto account settings',
    ClickCreateBatchEmail = 'create batch email',
    ClickSortBySubject = 'sort by subject',
    ClickSortByDate = 'sort by date',
    ClickBatchEmailRow = 'batch email row',
    // #endregion BATCH EMAILS

    // #region PIPELINE EVENTS
    PipelineMoveStage = 'pipeline_view: Move to stage',
    PipelineMoveToStageSuccess = 'pipeline: dropdown moving to stage Successful pipeline_quick_action',
    PipelineMoveToStageFail = 'pipeline: dropdown moving to stage Failed pipeline_quick_action',
    PipelineInvoiceBannerCreateInvoice = 'pipeline_invoice_banner_create_invoice',
    QuickSendSmartFilw = 'quick send flow button',
    GoToContract = 'go to contract',
    PipelineTourStart = 'pipeline tour start',
    PipelineCustomize = 'pipeline customize',
    LoadedPipeline = 'loaded: pipeline',

    // ng2react
    // GoToWorkspaceFromPipeline = 'go to workspace'

    PipelineAction = 'pipeline action',
    ReferWorkspace = 'refer workspace',
    DeleteWorkspace = 'delete workspace',
    AdminMoveWorkspace = 'admin move workspace',
    PipelineErrorStateRefresh = 'pipeline error state refresh',
    PipelineNewEvent = 'new event',
    ArchivedWorkspacesReportRequested = 'archived workspaces report requested',
    ArchivedWorkspacesReportGenerated = 'archived workspaces report generated',
    ArchivedWorkspacesReportGeneratationFailed = 'archived workspaces report generation failed',
    PipelineBulkAction = 'pipeline bulk action',
    BulkWorkspaceEmail = 'bulk workspace email',
    // #endregion PIPELINE EVENTS

    InviteTeamMemberSeePlans = 'invite team member see plans',
    OpenInviteTeamMemberModal = 'open invite team member modal',
    DismissInviteTeamMemberBanner = 'dismiss invite team member banner',

    // #region AUTOMATIONS-LIST
    LoadAutomationsListPage = 'workflowsview',
    AutomationUpdatedProjectType = 'workflow: update project type',
    AutomationUpdatedLeadForm = 'workflow: update public flows',
    GoToAutomation = 'go to workflow',
    // #endregion AUTOMATIONS-LIST

    // #region INTEGRATIONS
    IntegrationsPageLoad = 'integrations page',
    IntegrationLearnMore = 'integrations: learn more url',
    IntegrationCTA = 'integrations: CTA button',
    IntegrationDisconnect = 'integrations: disconnect button',
    IntegrationDisconnectConfirmed = 'integrations: disconnect confirmed',
    IntegrationCog = 'integrations: cog',
    FacebookSDKLoadTime = 'integrations: facebook sdk load time',
    // #endregion INTEGRATIONS

    // #region PIC-TIME INTEGRATION
    PicTimeIntegrationCanceled = 'integrations: pic-time integration canceled',
    PicTimeIntegrationSuccess = 'integrations: pic-time integration success',
    PicTimeIntegrateAfterPromo = 'integrations: pic-time integration after entering promo code',
    PicTimeIntegrationError = 'integrations: pic-time integration error',
    PicTimeConnectExistingGallery = 'connect existing pic-time gallery',
    PicTimeCreateGallery = 'create pic-time gallery',
    PicTimeConnectAfterWelcome = 'go to connect pic-time integration after welcome modal',
    PicTimeConnectAccountModal = 'connect pictime account modal',
    PicTimeConnectionSuccessModal = 'pictime connection success modal',
    // #endregion PIC-TIME INTEGRATION

    // #region JOHN BRANCH TEMPLATES
    JBWelcomeModalClosed = 'john branch: welcome modal closed',
    JBWelcomeModalViewTemplates = 'john branch: view templates',
    JBWelcomeModalGoHome = 'john branch: go home',
    // #endregion JOHN BRANCH TEMPLATES

    // #region ZAPIER TEMPLATES
    zapierTemplateConnect = 'integrations: connect zapier template',
    zapierTemplateStart = 'integrations: start zapier template',
    ZapierZapTemplate = 'integrations: zapier zap template',
    // #endregion ZAPIER TEMPLATES

    // #region PAYMENTS PAGE
    CheckPricing = 'check pricing',
    GoToHelpCenter = 'go to help center',
    GoToHelpCenterFromClientPortal = 'client portal open help center article',
    PaymentsHubQuestionOpen = 'Payments hub question open',
    PaymentsHubQuestionLink = 'Payments hub question link',
    // #endregion PAYMENTS PAGE

    // #region FEED ITEM - EMAIL VIEWER
    RemoveScheduledSend = 'remove scheduled send',
    DownloadFile = 'download attachment',
    SmartFilePreviewAction = 'flow three dots menu action',
    ViewPVL = 'view pvl',
    // #endregion FEED ITEM - EMAIL VIEWER

    Carousel = 'carousel',
    CarouselItem = 'carousel item',

    // #region ONBOARDING QUIZ
    OnboardingQuiz = 'mobile onboarding quiz',
    OnboardingQuizLoaded = 'QuizQuestionLoaded',
    OnboardingQuizSkip = 'mobile onboarding quiz skip',
    OnboardingQuizSkip2 = 'QuizQuestionSkipped',
    OnboardingQuizBack = 'QuizBackClicked',
    OnboardingQuizStepCtaClicked = 'QuizQuestionAnswered',
    OnboardingQuizAvgRevenueAbove20k = 'Revenue Quiz Above 20k',
    OnboardingQuizQuestionAnswered = 'mobile onboarding quiz answer',
    OnboardingQuizAnswersPayload = 'quiz',
    OnboardingQuizDone = 'mobile onboarding quiz done',
    OnboardingQuizDone2 = 'QuizDone',
    // #endregion ONBOARDING QUIZ

    // #region AI IMAGES
    AiImagesSavedToLibrary = 'save to hb library',
    AiImagesDownload = 'download',
    AiImagesToolLoad = 'load: AI_images_tool',
    AiImagesSavedToLibraryAction = 'action: save to hb library',
    AiImagesDownloadAction = 'action: download',
    AiImageSavedToLibrarySuccess = 'server: AI_image_saved_to_library',
    AiImagesWelcomeModalLoad = 'load: AI_images_intro',
    // #endregion AI IMAGES

    InvoicesReportFilter = 'invoice report filter',
    InvoicesReportSort = 'invoice report sort',
    InvoicesReportRowClick = 'invoice report row click',
    InvoicePreviewModal = 'invoice preview modal',
    InvoiceReportNavigation = 'invoice report navigation',

    // #region Schedule Meeting Modal
    ScheduleMeetingModal = 'schedule meeting modal',
    ScheduleMeetingModalDiscardMeetingChanges = 'discard meeting changes',
    ScheduleMeetingModalClose = 'close schedule meeting modal',
    ScheduleMeetingModalCreateError = 'create meeting error',
    ScheduleMeetingModalUpdateMeetingError = 'update meeting error',
    ScheduleMeetingModalConnectProject = 'connect project',
    ScheduleMeetingModalZoomCancelOnClose = 'cancel zoom meeting on close modal',
    // #endregion Schedule Meeting Modal

    // Digital products
    ClientPortalEditUrl = 'client portal edit url',

    // Project participants
    AddProjectParticipant = 'add project participant',
    UserAvatar = 'user avatar',
    GoToClientWorkspace = 'go_to_client_workspace',
    GoToOrganization = 'go_to_organization',
    ParticipantInfo = 'participant_info',
    RemoveFromProject = 'remove_from_project',
    CopyEmail = 'copy email',
    CopyPhone = 'copy phone',
    // End Project participants

    // #region SERVICES HUB
    OpenSendInvoiceModal = 'open send invoice modal',
    SendInvoiceFromServiceTemplate = 'send invoice from service template',
    CreateServiceTemplate = 'create service template',
    UpdateServiceTemplate = 'update service template',
    DeleteServiceTemplate = 'delete service template',
    ConfirmDeleteServiceTemplate = 'confirm delete service template',
    DismissDeleteServiceTemplate = 'dismiss delete service template',
    DuplicateServiceTemplate = 'duplicate service template',
    SearchServiceTemplates = 'search service template',
    SortServiceTemplates = 'sort service template',
    OpenServiceTemplateModal = 'open service template modal',
    KeepEditingServiceTemplateModal = 'keep editing service template modal',
    KeepEditingServiceTemplateSubItemsModal = 'keep editing service template subitems modal',
    CloseServiceTemplateModal = 'close service template modal',
    CloseServiceTemplateSubItemsModal = 'close service template subitems modal',
    FirstTimeInvoiceExperienceAppears = 'first time experience appears',
    FirstTimeInvoiceExperienceClicked = 'first time experience clicked',
    FirstTimeInvoiceExperienceClosed = 'first time experience closed',
    SaveServiceFromSidebar = 'save service from sidebar',
    SaveServiceFromModal = 'save service from modal',
    ViewServicesFromToast = 'view services hub from toast',
    // #endregion

    // #region DIGITAL PRODUCTS
    DigitalProductServiceClickBuilderToggle = 'builder_digital_product_service_switch_click',
    DigitalProductLinkClickCxThankYouPage = 'cx_thank_you_page_digital_product_link_click',
    // #endregion DIGITAL PRODUCTS

    UploadImage = 'upload image from library',
    // #region TIME TRACKER
    LoadTimeTrackerPage = 'TimeTrackerTool',
    TimeTrackerAddEntry = 'time_tracker_add_entry',
    TimeTrackerEntryModal = 'time_tracker_entry_modal',
    TimeTrackerEntryModalEntrySaved = 'time_tracker_entry_modal_entry_saved',
    TimeTrackerEntryDeleted = 'time_tracker_entry_deleted',
    TimeTrackerEntryEdit = 'time_tracker_entry_edit',
    TimeTrackerEntryModalEntryEdited = 'time_tracker_entry_modal_entry_edited',
    TimeTrackerCsvDownloaded = 'time_tracker_csv_downloaded',
    TimeTrackingChangeFilter = 'time tracking: change filter',
    TimeTrackerOpenCreateInvoiceModal = 'time_tracker_open_create_invoice_modal',
    timeTrackerToolInvoiceModal = 'time_tracker_tool_invoice_modal',
    timeTrackerToolAddProject = 'time_tracker_tool_add_project',
    timeTrackerFullModal = 'time_tracker_full_modal',
    TimeTrackerCreateInvoice = 'time_tracker_create_invoice_next',
    // #endregion TIME TRACKER

    // Lead Forms Redirect Url
    RedirectUrlClickCxThankYouPage = 'cx_thank_you_page_redirect_url_click',
    // #endregion Lead Forms Redirect Url

    // Lead Forms Assign Team Members
    AssignTeamMembersModalPublicFlowClick = 'assign_team_members_modal_click',
    AssignTeamMembersModalPublicFlowSaveClick = 'assign_team_members_modal_save_click',
    // #endregion Lead Forms Assign Team Members

    // Cancellation flow
    CancelMembership = 'cancel membership',
    PauseMembership = 'pause membership',
    KeepPlan = 'keep plan',
    CancelReasons = 'cancel reasons',
    NextToCancelMembership = 'next to cancel membership',
    NextToPauseMembership = 'next to pause membership',
    CancelTextareaFeedback = 'cancel textarea feedback',
    CancellationFeedback = 'cancellation feedback',
    SuggestionCta = 'suggestion cta',
    HowToArchive = 'how to archive',

    // TIN Resolve flow
    TINVerificationModal = 'tin verification modal',
    TINVerificationModalDismiss = 'tin verification modal dismiss',
    TINVerificationModalStep = 'tin verification modal step',
    TINResolveModalFilingMethod = 'tin resolve modal filing method',
    TINResolveModalEntitySelected = 'tin resolve modal entity selected',

    // #region REFERRAL PERKS
    PerksPageLoad = 'perks page',
    PerksCopyCode = 'perks: copy code',
    PerksClaimOffer = 'perks: claim offer',
    PerksProvideFeedback = 'perks: provide feedback',
    // #endregion REFERRAL PERKS

    // OOO
    OooEditReply = 'ooo_edit_reply',
    OooSaveReply = 'ooo_save_reply',
    OooModeToggle = 'ooo_mode_toggle',
    OooActivityToggle = 'ooo_activity_toggle',

    // #region One Home
    Projects = 'projects',
    IntegrationsCtaButton = 'integrations: CTA button',
    Templates = 'templates',
    GoToTemplate = 'go to template',
    CalendarItem = 'calendar item',
    Calendar = 'calendar',
    Tasks = 'tasks',
    LeadForms = 'public_flows',
    CreateAgreement = 'create agreement',
    CreateProposal = 'create proposal',
    ActivityNotification = 'activity notification',
    CreateFirstSession = 'create first session',
    GoToPayments = 'go to payments',
    ReorderContractAndScheduler = 'reorder contract and scheduler',
    AddSchedulerToContractWithSessionFields = 'add scheduler to contract with session fields',
    OneHomeLinkResource = 'home link resource',
    OneHomeQuickLinkResource = 'home quick link resource',
    OneHomeProductTipResource = 'home product tip resource',
    OneHomeMediaResource = 'home media resource',
    // #endregion One Home

    // Feature requested modal
    FeatureRequestedModal = 'feature requested modal',
    FeatureRequestedModalDismiss = 'feature requested modal dismiss',
    FeatureRequestedModalSubmit = 'feature requested modal submit',
    FeatureRequestedModalLearnMore = 'feature requested modal learn more',

    // #endregion One home

    // #region CREATE PROJECT
    CreateProjectModal = 'create project modal',
    CreateProjectModalClose = 'close create project modal',
    CreateProjectModalCreateError = 'create project modal create error',
    CreateProjectModalDateCollisionError = 'create project modal date collision error',
    CreateProjectModalProjectCreated = 'project created',
    CreateProjectModalProjectCreatedError = 'create project',
    CreateProjectModalCreateProject = 'project created modal',
    CreateProjectModalAddEndDate = 'add end date',
    CreateProjectModalEditProjectName = 'edit project name',
    CreateProjectModalEditProjectStartDate = 'edit project start date',
    CreateProjectModalEditProjectEndDate = 'edit project end date',
    CreateProjectModalEditProjectStartTime = 'edit project start time',
    CreateProjectModalEditProjectEndTime = 'edit project end time',
    CreateProjectModalEditProjectTimezone = 'edit project timezone',
    CreateProjectModalRemoveEndDate = 'remove end date',
    // #endregion CREATE PROJECT

    // #region PROJECT TYPE DROPDOWN
    ProjectTypeDropdownCreateProjectType = 'create project type',
    ProjectTypeDropdownCreateProjectTypeError = 'create project type error',
    ProjectTypeDropdownEditProjectType = 'edit project type',
    // #endregion PROJECT TYPE DROPDOWN

    // #region LEAD SOURCE DROPDOWN
    LeadSourceDropdownCreateLeadSource = 'create lead source',
    LeadSourceDropdownCreateLeadSourceError = 'create lead source error',
    LeadSourceDropdownEditLeadSource = 'edit lead source',
    // #endregion LEAD SOURCE DROPDOWN

    // #region AssignWorkspaceToMember
    AssignWorkspaceToTeamMember = 'assign workspace to team member',
    AssignWorkspaceToTeamMemberClickDone = 'send',
    AssignWorkspaceToTeamMemberError = 'error when assigning workspace to team member',
    AssignWorkspaceToTeamMemberToggleSelection = 'select member',
    // #endregion AssignWorkspaceToMember

    // #region "Refer to vendor" modal
    ReferToVendorModalClosed = 'add user modal closed',
    ReferToVendorModalFormSubmitted = 'done with add user modal',
    ReferToVendorModalFormSubmissionFailed = 'user save failed',
    ReferToVendorModalNewVendorReferralContactCreated = 'vendor added for referral',
    // #endregion "Refer to vendor" modal

    // #region CONTACTS UPLOAD MODAL
    ContactsUploadSpreadsheetModal = 'contacts upload spreadsheet modal',
    ContactsUploadSpreadsheetModalImportError = 'contacts upload spreadsheet modal import error',
    ContactsUploadSpreadsheetModalClose = 'closed upload clients modal',
    ContactsUploadSpreadsheetModalDownloadExampleCsv = 'download clients csv example',
    ContactsUploadSpreadsheetModalLearnMore = 'upload clients learn more',
    ContactsUploadSpreadsheetModalFinished = 'finished uploading clients csv',
    // #endregion CONTACTS UPLOAD MODAL

    // #region UPLOAD QUESTION BLOCK
    AddAttachmentToFileUploadBlock = 'add attachment to file upload block',
    DeleteAttachmentFromFileUploadBlock = 'delete attachment from file upload block',
    // #endregion UPLOAD QUESTION BLOCK

    // #region users account info
    UserAccountInfoEmailFieldClicked = 'user email field clicked',
    UserAccountInfoEmailChangeSuccess = 'user email changed',
    UserAccountInfoEmailChangeFailure = 'account email not changed',
    UserInfoChanged = 'personal info changed',
    UserAccountInfoPasswordChangeSuccess = 'user password changed',
    UserAccountInfoPasswordChangeFailure = 'user password not changed',
    UserAccountInfoSendPasswordLinkSuccess = 'user change password link sent',
    UserAccountInfoSendPasswordLinkFailure = 'user change password link not sent',
    UserAccountInfoSendSecurityPhoneNumberSuccess = 'user update security phone number success',
    UserAccountInfoSendSecurityPhoneNumberFailure = 'user update security phone number failure',
    UserAccountInfoAddSecurityPhoneNumber = 'add security phone number',
    UserAccountInfoEditSecurityPhoneNumber = 'edit security phone number',
    UserAccountInfoSaveSecurityPhoneNumber = 'save security phone number',
    UserAccountInfoCancelSecurityPhoneNumber = 'cancel security phone number',
    // #endregion users account info

    TaskAssignTaskTo = 'assign_task_to',

    // Tags
    TagAddedToWs = 'tag_added_to_object'
}
